<template>
  <div class="login-container">
    <div class="leftC">
      <div class="blank"></div>
      <div class="loginCard">
        <div class="content">
          <div class="title">
            <div class="img">
              <img src="@/assets/pubrio-logo.webp"/>
            </div>
            <h1>{{ $t('logIn') }}</h1>
          </div>
          <div class="text">{{ $t('WelcomeBack') }}! {{ $t('PleaseEnterYourEmailAndPassword') }}</div>
          <div class="form">
            <div class="row">
              <div class="form-title">
                {{ $t('email') }}
              </div>
              <input class="form-input" v-model="loginForm.email" placeholder="example@gmail.com" />
            </div>
            <div class="row">
              <div class="form-title">
                {{ $t('password') }}
              </div>
              <input class="form-input" :type="passwordType"
                     v-model="loginForm.password"
                     @keyup.enter ="handleLogin"
                     :placeholder="$t('CharactersRequired')" />
              <span class="show-pwd" @click="showPwd">
                  <svg-icon :icon-class="passwordType === 'password' ? 'eye-off' : 'eye'" />
              </span>
            </div>

          </div>
          <div class="keep-sign">
            <div class="left">
              <el-switch
                  v-model="isSigned"
                  active-color="#013CF3"
                  inactive-color="#E1E2E6">
              </el-switch>
              <span>
                 {{ $t('keepMeSignedIn') }}
              </span>
            </div>
            <div class="forget">
              <router-link to="forgot">{{ $t('forgetPassword') }}?</router-link>
            </div>
          </div>
          <el-button class="btn-sub"
                     size="medium"
                     :disabled="disabled"
                     :loading="loading"
                     type="primary"
                     @click.native.prevent="handleLogin">{{ $t('logIn') }}</el-button>
          <div class="sign-up">
            <span>{{ $t('dontHaveAnAccount') }}</span>
            <router-link to="signup">{{ $t('signUpNow') }}</router-link>
          </div>
        </div>
      </div>
      <div class="blank"></div>
      <div class="footer">
        <div>2023 Pubrio {{ $t('AllRightsReserved')}}</div>
        <div>
             <span><a href="http://www.pubrio.com/privacy">{{ $t('privacyPolicy') }} </a>
            {{ $t('and') }}
            <a href="http://www.pubrio.com/terms">{{ $t('termsOfService') }}</a>.
          </span>
        </div>

      </div>
    </div>
    <div class="rightC">
      <div class="img">
        <img src="@/assets/common/login-right.png"/>
      </div>
      </div>

  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        email:'',
        password: ''
      },
      loading: false,
      passwordType: 'password',
      isSigned:true, //keepsigned
    }
  },
  computed:{
    ...mapState('user',['currentId','systemConfig']),
    disabled(){
       return !(this.loginForm.email && this.loginForm.password);
    },
    text_field_max_length(){
      return this.labelTypeItem?.crm_schema_column_text_field_max_length_limit
    },
    userId(){
      return this.currentId.profile_id
    }

  },
  watch:{
    userId(){
      this.getInfoBasedOnId()
    }
  },
  methods: {
    ...mapActions('user',['login','getUserInfo','getConfig']),
    ...mapActions('account',['getUserList','getProfile']),
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    async handleLogin() {
      try{
        this.loading = true
        await this.$store.commit('user/setIsSigned', this.isSigned)
        await this.login(this.loginForm)
        await this.getUserInfo() //获得profileList
        await this.$router.push(this.$route.query.returnUrl || '/')
        let mes = this.$t('LoginSuccess')
        this.$message.success(mes)
        await this.getInfoBasedOnId()
      }finally {
        this.loading = false
      }
    },
    async getInfoBasedOnId(){
      await this.getUserList({profile_id: this.userId, is_current:true}) //获得当前用户信息
      await this.getConfig({profile_id: this.userId}) //获得配置信息
      await this.getProfile({profile_id:this.userId}) //获得account信息
      //为所有的input 添加maxlength
      const inputs = this.$el.querySelectorAll('input');
      inputs.forEach(input => {
        input.setAttribute('maxlength', this.text_field_max_length);
      });
    }
  },

  }
</script>

<style scoped lang="scss">
.login-container {
  display: flex;
  height: 100%;
  width: 100%;
  overflow: auto;
  .leftC{
    flex:1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .footer{
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin-bottom:24px;
      gap:20px;
      font-size: 14px;
      line-height: 17px;
      font-weight: 400;
    }
  }
  .blank{
    flex:1;
  }
  .loginCard{
    margin: 0 auto;
   // padding-top: 162px;
    .content{
      padding: 45px 52px;
      .title{
        display: flex;
        align-items: center ;
        .img{
          width: 40px;
          height: 40px;
          border-radius: 8px;
          margin-right: 8px;
          img{
            width: 100%;
            border-radius: 8px;
          }
        }
        h1{
          font-weight: 500;
          font-size: 32px;
          line-height: 38px;
          color: $color-black;
        }

      }
      .text{
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        white-space: nowrap;
        margin-bottom: 40px;
        color: $color-black;
      }
      .form{
        display: flex;
        flex-direction: column;
        gap:10px;
        margin-bottom: 16.7px;
        color: $color-black;
        .row{
          position: relative;
          .show-pwd{
            position: absolute;
            right: 30px;
            top: 50%;
            cursor: pointer;
            .svg-icon{
              width: 16px;
              height: 16px;
            }
          }
        }

        .form-title{
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;
          margin-bottom: 8px;
        }
        .form-input{
          padding: 0 16px;
          width: 336px;
          height: 48px;
          border: 1px solid $color-gray-0;
          border-radius: 8px;
        }
        .form-input::placeholder{
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;
          color: $color-gray-1;
        }
        .form-input:hover{
          border: 1px solid $color-gray-1;
        }
        .form-input:focus{
          border: 1px solid $color-blue-5;
        }
      }
      .keep-sign{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left{
          ::v-deep .el-switch__core{
            width: 31px!important;
            height: 20px!important;
          }
          span{
            margin-left: 8px;
            font-weight: 400;
            font-size: 14px;
            line-height: 17px;
            color:#98A1B3;
          }
        }
        .forget{
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;
          color: $color-blue-6;
        }
      }
      .sign-up{
        display: flex;
        justify-content: center;
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        color: $color-black;
        a{
          color: $color-blue-6;
          margin-left:2px;
        }
      }
    }
  }

  .rightC{
    padding:24px 0;
    height: 100%;
    .img{
      width: 100%;
      height: 100%;
      overflow: hidden;
      img{
        height:100%;
      }
    }
  }
  @media (max-width: 991px) {
    .rightC{
      display: none;
    }
  }
}
</style>

